<app-section-layout [itemTemplate]="capexGraph" [dataForChart]="graphData"></app-section-layout>

<ng-template #capexGraph let-data="data">
        <div class="pie-top-text">{{selectedItem ? selectedItem.title : '&nbsp;'}}</div>
        <div class="pie-middle-text">
            <span class="actual">{{selectedItem ? selectedItem.actual : '&nbsp;'}}</span>
            <span class="text">{{selectedItem ? 'Actual' : '&nbsp;'}}</span>
        </div>
        <div echarts [id]="chartId" [options]="options" class="chart-container" (chartInit)="onChartInit($event)"></div>
        <div class="pie-bottom-text">{{selectedItem ? '' + selectedItem.budgetDeltaNumber + ' (' + selectedItem.budgetDeltaPercent + '%) ' + (selectedItem.isOverBudget ? 'Above' : 'Under') + ' Budget'  : '&nbsp;'}}</div>
</ng-template>
